import React from "react";
import styled from 'styled-components';
import Header from '../../components/common/header/Header';
import Footer from '../../components/common/Footer';
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { setCurMenuAction, setHeaderTransferAction } from "../../modules/common/headerModule";
import { Link } from "react-router-dom";
import { getFaqAction } from "../../modules/cs/customserviceModule";
import LoadingOverlay from 'react-loading-overlay';
import FaqAccoItem from "../../components/cs/FaqAccoItem"
import Pagination from '../../components/common/Pagination';
import queryString from "query-string";
import { useHistory } from 'react-router-dom';
import { isIE, isChrome, isMobileOnly } from "react-device-detect";

const FaqBlock = styled.div`
    ${!isMobileOnly&&"min-width: 1236px"};
`;

const FaqContainerBlock = styled.div`
    ${isMobileOnly?`
    padding-top: 60px;   
  `:`
    padding-top: 80px;
  `};
`;

const FaqWrapClearfix = styled.div`
    //width: 100%;
    ${isMobileOnly?`
       margin: 0 4vw;     
  `:`
      width: 1176px;
      margin: 0 auto;
  `};

    ::after {
        content: '';
        display: block;
        clear: both;
    }
`;

const FaqCSLeftLinkBlock = styled.div`
    left: 0;
    position: absolute;
    top: 0;
    color: #999;
    font-size: 20px;
    font-weight: 500;

    ::before {
        content: '';
        display: inline-block;
        width: 8px;
        height: 16px;
        margin-right: 20px;
        background: url(/assets/images/icon/faq_arrow-icon.png) center center/cover no-repeat;
    }
`;

const FaqCStitleH2Block = styled.h2`
    font-size: 32px;
    font-weight: 500;
    text-align: center;

    ::before {
        content: '';
        display: inline-block;
        width: 43px;
        height: 37px;
        margin-right: 20px;
        background: url(/assets/images/icon/faq-icon.png) center center/auto no-repeat;
        vertical-align: -4px;
    }
`;

const FaqCSRightLinkBlock = styled.div`
    right: 0;
    position: absolute;
    top: 0;
    color: #999;
    font-size: 20px;
    font-weight: 500;

    ::after {
        content: '';
        display: inline-block;
        width: 8px;
        height: 16px;
        margin-left: 20px;
        background: url(/assets/images/icon/faq_arrow-icon.png) center center/cover no-repeat;
        -webkit-transform: rotate(180deg);
        -ms-transform: rotate(180deg);
        transform: rotate(180deg);
    }
`;

const FaqContentContainerBlock = styled.div``;

const FaqTabUlBlock = styled.ul`
`;

const FaqTabLiBlock = styled.li`

`;

const FaqTabButtonBlock = styled.button`
    color: ${props => props.colorf};
`;

const FaqListUlBlock = styled.ul`
`;

const StyleLoader = styled(LoadingOverlay)`

    padding:0px;
    margin : 0px;

  .MyLoader_overlay {
    background: rgba(0, 0, 0, 0.1);
  }
  &.MyLoader_wrapper--active {
    overflow: hidden;
  }
`;


const CateOption = [
    { value: "all", label: "전체" },
    { value: "125101", label: "견적" },
    { value: "125102", label: "주문/결제" },
    { value: "125103", label: "배송" },
    { value: "125104", label: "취소/환불" },
    { value: "125105", label: "교환/반품" },
    { value: "125106", label: "기타" },
];


const FaqMain = ({ location }) => {
    const [curTabIndex, setCurTabIndex] = useState(0);
    const dispatch = useDispatch();
    const [curPage, setCurPage] = useState(1);
    const [totalCount, setTotalCount] = useState(-1);
    const [curSelId, setCurSelId] = useState(-1);
    const [query, setQuery] = useState(queryString.parse(location.search));
    const [fromFooter, setFromFooter] = useState(false);
    const [itemIndex, setItemIndex] = useState(-1);
    const history = useHistory();

    const { loading, listData } = useSelector(
        ({ userReducer, loadingReducer, customserviceReducer }) => ({
            registError: userReducer.registError,
            loading: loadingReducer['customservice/GET_FAQ'],
            listData: customserviceReducer.listData
        })
    );

    useEffect(() => {

        let query =null;
        if(history && history.location && history.location.state && history.location.state.link){
            query = queryString.parse(history.location.state.link)
        }
        //console.log('query = '+JSON.stringify(query))
        //let query = queryString.parse(location.search);
        dispatch(setCurMenuAction('faq'));
        dispatch(setHeaderTransferAction(false));
        setCurPage(1);
        if (query === null || query.faq_type === undefined) {
            setCurTabIndex(0)
            dispatch(getFaqAction(CateOption[0].value, 1));
            setFromFooter(false);
        }
        else if (query !== null && query.faq_type !== null && query.faq_type.length > 0 && query.id !== undefined &&  query.id !== null && query.id.length > 0) {
            let index = CateOption.findIndex(x => x.value === query.faq_type);
            setCurTabIndex(index)
            dispatch(getFaqAction(CateOption[index].value, 1));
            setCurSelId(parseInt(query.id));
            setQuery(null);
            setFromFooter(true);
        }
        else if (query !== null && query.faq_type !== null && query.faq_type.length > 0 && query.page !== undefined && query.page !== null && query.page.length > 0) {
            let index = CateOption.findIndex(x => x.value === query.faq_type);
            setCurTabIndex(index)
            //dispatch(getFaqAction(CateOption[index].value, 1));
            setCurPage(parseInt(query.page));
            dispatch(getFaqAction(CateOption[index].value, parseInt(query.page)));
            //setCurSelId(parseInt(query.id));
            setCurSelId(-1);
            setQuery(null);
            setFromFooter(false);
        }
        else {
            dispatch(getFaqAction(CateOption[curTabIndex].value, 1));
            setFromFooter(false);
        }


        window.scrollTo(0, 0);
    }, [location]);

    useEffect(() => {
        if (listData !== null) {
            setTotalCount(listData.count);
        }
    }, [listData]);

    useEffect(() => {
        //if(fromFooter === true){
        if (itemIndex >= 0) {
            setTimeout(() => {
                let height = 90 + 98 + itemIndex * 72;
                window.scrollTo(0, height);
            }, 1000);
        }

    }, [itemIndex]);

    const handleChangePageNum = (value) => {
        if(value === curPage){
            return;
        }
        setQuery(null);
        /* setCurPage(value);
        dispatch(getFaqAction(CateOption[curTabIndex].value, value));
        setCurSelId(-1);
        window.scrollTo(0, 0); */
        let link = 'faq_type=' + CateOption[curTabIndex].value + '&page='+value;
        //history.push("/faq?" + link);
        history.push("/faq",{ link: link })
    }


    const handleTabButton = (index) => {
        setQuery(null);
        setFromFooter(false);
        if (curTabIndex !== index) {
            /* setCurTabIndex(index);
            setCurPage(1);
            setCurSelId(-1);
            dispatch(getFaqAction(CateOption[index].value, 1)); */
            let link = 'faq_type=' + CateOption[index].value + '&page='+'1';
            //history.push("/faq?" + link);
            history.push("/faq",{ link: link })
        }
    }

    const handleAccBtn = (id) => {
        setQuery(null);
        setFromFooter(false);
        if (curSelId === id) {
            setCurSelId(-1);
        }
        else {
            setCurSelId(id);
        }
    }

    const handleFooterClick = (link) => {
        let linkQuery = queryString.parse(link);
        // console.log(linkQuery);
        if (linkQuery === null || linkQuery.faq_type === undefined) {

        }
        else if (linkQuery !== null && linkQuery.faq_type !== null && linkQuery.faq_type.length > 0) {
            let index = CateOption.findIndex(x => x.value === linkQuery.faq_type);
            setCurTabIndex(index)
            dispatch(getFaqAction(CateOption[index].value, 1));
            setCurSelId(parseInt(linkQuery.id));
        }
    }



    if (totalCount === -1) {
        return (
            <FaqBlock>
                <Header />
                <FaqContainerBlock>
                    <div style={{ height: '500px' }}></div>
                </FaqContainerBlock>
                <Footer />
            </FaqBlock>
        );
    }

    return (
        <FaqBlock>
            <StyleLoader
                active={loading}
                //active = "false"
                spinner
                text=''
                classNamePrefix='MyLoader_'>
                <Header />
                <FaqContainerBlock>
                    <div>
                        <div className="mypage-section" style = {isMobileOnly? {padding:'10vw 0 120px'}:{}}>
                            <FaqWrapClearfix>
                                {isMobileOnly ?
                                    <div><div className="cs_title-wrap margin_b-30" style = { {height:'8vw'}}>
                                        <Link to={"/notice"}><FaqCSLeftLinkBlock>공지 알리미</FaqCSLeftLinkBlock></Link>

                                        <Link to={"/consult"}><FaqCSRightLinkBlock>1:1 문의</FaqCSRightLinkBlock></Link>
                                    </div>
                                    <div className=" margin_b-50">
                                    <FaqCStitleH2Block>자주 찾는 질문</FaqCStitleH2Block>
                                    </div></div>
                                :
                                    <div className="cs_title-wrap margin_b-60">
                                        <Link to={"/notice"}><FaqCSLeftLinkBlock>공지 알리미</FaqCSLeftLinkBlock></Link>
                                        <FaqCStitleH2Block>자주 찾는 질문</FaqCStitleH2Block>
                                        <Link to={"/consult"}><FaqCSRightLinkBlock>1:1 문의</FaqCSRightLinkBlock></Link>
                                    </div>
                                }
                                <FaqContentContainerBlock>
                                    <div className="filter-top border_none clearfix" style = {isMobileOnly? {width:'100%', overflowX: 'scroll', overflowY: 'hidden', position:'relative'}:{}}>
                                        <FaqTabUlBlock className="tab-list f-left clearfix" style = {isMobileOnly? {width:'max-content'}:{}} >
                                            {
                                                CateOption.map((item, index) => {
                                                    return (
                                                        <FaqTabLiBlock key={item.value} className={curTabIndex === index ? "active" : ""}
                                                        style = {isMobileOnly? {padding:'20px 2vw',display: 'flex',height: '100%',justifyContent: 'center'}:{}}>
                                                            <FaqTabButtonBlock className="green_border" onClick={() => handleTabButton(index)}
                                                                colorf={curTabIndex === index ? "#111" : "#999"}>
                                                                {item.label}
                                                            </FaqTabButtonBlock>
                                                        </FaqTabLiBlock>
                                                    );
                                                })
                                            }
                                        </FaqTabUlBlock>
                                    </div>
                                    <FaqListUlBlock className="qna-acco margin_b-40">
                                        {
                                            listData.dataList.map((dataInfo, index) => {
                                                if (dataInfo.id === curSelId && fromFooter === true) {
                                                    setItemIndex(index);
                                                    setFromFooter(false);
                                                }
                                                return <FaqAccoItem key={dataInfo.id.toString() + CateOption[curTabIndex].value} dataInfo={dataInfo}
                                                    clickHandler={handleAccBtn}
                                                    active={dataInfo.id === curSelId} />
                                            })
                                        }
                                    </FaqListUlBlock>
                                    <Pagination updatePageNum={handleChangePageNum} prodItems={listData} />
                                </FaqContentContainerBlock>
                            </FaqWrapClearfix>
                        </div>
                    </div>
                </FaqContainerBlock>

                <Footer evHandler={handleFooterClick} />
            </StyleLoader>

        </FaqBlock>
    );
};

export default FaqMain;
